import {Injectable} from '@angular/core';
import {BaseService, QueryParams} from '../../../core/abstracts/base-service.abstract';
import {Readable} from '../../../core/interfaces/base-service.interfaces';
import {GeocodingResponse} from '../model/geocoding-response.model';
import {map, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class GeocodingService extends BaseService implements Readable<GeocodingResponse> {
  protected override endpoint: string = "https://nominatim.openstreetmap.org";

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  public getOne(params?: QueryParams): Observable<GeocodingResponse> {
    return this.getExternal<GeocodingResponse[]>(this.endpoint, 'search', params, true)
      .pipe(
        map(response => response[0])
      );
  }
}
